import Layout from "@components/layout";
import { AccountPage, ShopsPage } from "@pages";
import { RouteConfig } from "@types";

export const settings = (): RouteConfig => {
  return {
    path: "settings",
    element: <Layout />,
    redirect: "account",
    children: [
      { path: "account", element: <AccountPage />, navKey: "settings.account" },
      {
        path: "salepoints",
        element: <ShopsPage />,
        navKey: "settings.salepoints",
      },
    ],
  };
};

export default settings;
